import { useQuery } from '@tanstack/react-query'
import { Video } from 'utils/types/watch-now'
import { client } from './api-client'

export const useGetYoutubeVideos = () =>
  useQuery<Video[], Error>(['getYoutubeVideos'], () =>
    client(`video/fetchYoutubeVideos`),
  )
